<template>
    <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-danger">{{ title }}</h4>
                    <button type="button" class="close" aria-label="Close" @click=" onClose()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <TheCustomFilePicker ref="filePicker" title="File import" 
                            :initialValue="fileUpload"  
                            error=""
                            :isReadOnly="false" 
                            :isRequire="false" 
                            :isMultiple="false"
                            @onChange="(files) => uploadFile(files)" 
                            :acceptFile="acceptFile"
                            :key="tempKey"/>
                    </div>
                    <!-- @onChange="(files) => { fileUpload = files }"  -->
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left"
                        @click=" onClose()">&nbsp;Thoát</button>
                    <div class="pull-right">
                        <button type="button" class="btn btn-outline-info mr-1"
                            @click="downloadImportSampleFile(filename);">&nbsp;Download mẫu</button>
                        <button type="button" class="btn btn-outline-success" @click=" onSubmit();">&nbsp;{{ confirmLabelButton }}</button>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
import TheCustomFilePicker from '@/components/shareComponents/TheCustomFilePicker.vue'
import axios from 'axios';
import objectDefaultValue from '@/config/object.env'
import { common } from '@/helper/common'
export default {
    name: "TheGetFileImportDialog",
    props: {
        title: String,
        confirmLabelButton: String,
        onClose: Function,
        onSubmit: Function,
        filename: String,
        acceptFile: String,
        modelValue: Array, // Use v-model binding with `modelValue` for the file list

    },
    emits: ['update:modelValue'], // Declare the emit for two-way binding
    components: {
        TheCustomFilePicker,
    },
    data() {
        return {
            fileUpload: [],
            tempKey: common.randomString(10),
        }
    },
    methods: {
        async downloadImportSampleFile(filename) {
            
            let pathFile = objectDefaultValue.IMPORT_SAMPLE_FILE_PATH + filename;
            try {
                const response = await axios.get(pathFile, {
                    responseType: 'blob', // Khai báo kiểu dữ liệu là blob.
                });

                // Tạo một đường dẫn tạm thời và tạo ra một liên kết ẩn để tải xuống.
                const tempUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = tempUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();

                // Giải phóng đường dẫn tạm thời sau khi tải xuống hoàn tất.
                window.URL.revokeObjectURL(tempUrl);
            } catch (error) {
                console.error('Lỗi khi tải tập tin:', error);
            }
        },

        async uploadFile(file){
            this.fileUpload = file
            this.$emit('update:modelValue', this.fileUpload);
        }
    },
    watch: {
        modelValue: {
            handler(newVal) {
                this.tempKey = common.randomString(10)
                this.fileUpload = newVal || []; // Update internal state when prop changes
            },
            immediate: true // Ensure watcher runs on component initialization
        }
    },
    async mounted() {
        this.fileUpload = this.modelValue
    },
}

</script>
<style>

</style>